import { z } from "zod";

/**
 * Apify tool action — stored in AgentExternalTool.actions when type = APIFY.
 * Always a single-element array with one "run" action.
 * Hardcoded in apify-store-fetch.service.ts for every Apify actor.
 *
 * The path contains the actor's identifier: /v2/acts/{username}~{name}/runs
 * The executor extracts the actor name from this path at runtime.
 */
export const ApifyActionSchema = z.object({
  operationId: z.literal("run"),
  name: z.string(),
  description: z.string().optional(),
  method: z.literal("POST"),
  path: z.string(),
  bodyFields: z.array(z.unknown()),
  parametersFields: z.array(z.unknown())
});

export type ApifyAction = z.infer<typeof ApifyActionSchema>;
